import { useQuery, type QueryKey, type UseQueryOptions } from '@tanstack/react-query'
import { useIsHydratingRender } from './use-hydrating-render'

// Withholds the OUTCOME for the hydration render only: a client-first cache entry — data or rejection — desyncs
// it from the SSR HTML (#418).
export function useClientOnlyQuery<TQueryFnData, TError, TData = TQueryFnData, TQueryKey extends QueryKey = QueryKey>(
  queryOptions: UseQueryOptions<TQueryFnData, TError, TData, TQueryKey>,
): { data: TData | undefined; isPending: boolean; isError: boolean } {
  const hydrating = useIsHydratingRender()
  const { data, isPending, isError } = useQuery(queryOptions)
  return hydrating ? { data: undefined, isPending: true, isError: false } : { data, isPending, isError }
}
